(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["no3-clearance-note"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('no3-clearance-note')) {
    customElements.define('no3-clearance-note', class extends HTMLElement {
      connectedCallback() {
        const refresh = () => {
          const now = Date.now();
          const end = Date.parse(this.dataset.end);
          this.hidden = now < Date.parse(this.dataset.start) || now >= end;
          if (now < end) this.clearanceTimer = setTimeout(refresh, Math.min(end - now + 10, 3600000));
        };
        refresh();
      }
      disconnectedCallback() { clearTimeout(this.clearanceTimer); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["no3-purchase-summary"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('no3-purchase-summary')) {
    customElements.define('no3-purchase-summary', class extends HTMLElement {
      connectedCallback() {
        this.form = this.closest('form');
        if (!this.form) return;
        try { this.variants = JSON.parse(this.querySelector('script').textContent); } catch { return; }
        this.priceNode = this.querySelector('.no3-purchase-summary__price');
        this.planNode = this.querySelector('.no3-purchase-summary__plan');
        this.termsNode = this.querySelector('.no3-purchase-summary__terms');
        this.periodNode = this.querySelector('.no3-purchase-summary__period');
        this.format = new Intl.NumberFormat(this.dataset.locale || 'nb', {style: 'currency', currency: this.dataset.currency || 'NOK'});
        this.refresh = () => this.sync();
        this.form.addEventListener('change', this.refresh);
        this.form.addEventListener('input', this.refresh);
        this.timer = setInterval(this.refresh, 500);
        this.sync();
      }
      resolveChoice(data) {
        const variant = this.variants.find(item => item.id === data.get('id'));
        const quantity = Number(data.get('quantity') || 1);
        if (!variant || !Number.isInteger(quantity) || quantity < 1) return null;
        const planId = data.get('selling_plan');
        const plan = planId ? variant.plans.find(item => item.id === planId) : null;
        if (planId && !plan) return null;
        const rawAmount = plan ? plan.price : variant.price;
        if (rawAmount == null) return null;
        const amount = Number(rawAmount);
        if (!Number.isFinite(amount)) return null;
        return {amount: amount * quantity, label: plan ? `${this.dataset.subscription} · ${plan.name}` : this.dataset.oneTime, subscription: !!plan};
      }
      sync() {
        if (!this.form?.isConnected) return;
        const choice = this.resolveChoice(new FormData(this.form));
        this.hidden = !choice;
        if (!choice) return;
        const price = this.format.format(choice.amount / 100);
        if (this.priceNode.textContent !== price) this.priceNode.textContent = price;
        if (this.planNode.textContent !== choice.label) this.planNode.textContent = choice.label;
        this.termsNode.hidden = !choice.subscription;
        if (this.periodNode) this.periodNode.hidden = !choice.subscription;
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        this.form?.removeEventListener('change', this.refresh);
        this.form?.removeEventListener('input', this.refresh);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
